












































import {Vue, Component} from "vue-property-decorator"

@Component({
  components: {}
})
export default class Goback extends Vue {
  mounted() {
    $(window).scroll(function () {
      if ($(window).scrollTop() >= 400) {
        $('.box-up').css({display: 'flex'})
      } else {
        $('.box-up').css({display: 'none'})
      }
    })

    $('.box-up').click(function () {
      $('html').animate({scrollTop: 0}, 200)
    })
  }
  chat(){
  }
}



// WEBPACK FOOTER //
// ./node_modules/_vue-loader@14.2.4@vue-loader/lib/selector.js?type=script&index=0!./src/views/frame/GoBack.vue